var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:[
        {
            'has-inline-label': _vm.hasInlineLabel,
            'has-placeholder': !!_vm.placeholder,
        },
        _vm.parentClass ]},[_c('label',{class:[
            {
                'move-label-to-top': _vm.moveLabelToTop,
            },
            'form-label' ],attrs:{"for":_vm.uniqueId}},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")]),_vm._v(" "),_c('textarea',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.inputValue),expression:"inputValue"}],class:[
            {
                'move-label-to-top': _vm.moveLabelToTop,
            },
            'form-control' ],attrs:{"id":_vm.uniqueId,"placeholder":_vm.inputPlaceholder,"rows":_vm.rows},domProps:{"value":(_vm.inputValue)},on:{"focusin":function($event){_vm.focus = true},"focusout":function($event){_vm.focus = false},"input":[function($event){if($event.target.composing){ return; }_vm.inputValue=$event.target.value},_vm.handleInput]}},'textarea',_vm.$attrs,false)),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }